__turbopack_context__.v({
  "About": "kQc2fa_About",
  "AboutItem": "kQc2fa_AboutItem",
  "AllowOverflow": "kQc2fa_AllowOverflow",
  "BlueGreen": "kQc2fa_BlueGreen",
  "BlurbContainer": "kQc2fa_BlurbContainer",
  "Blurbs": "kQc2fa_Blurbs",
  "Contact": "kQc2fa_Contact",
  "ContactLinks": "kQc2fa_ContactLinks",
  "Email": "kQc2fa_Email",
  "Gradient": "kQc2fa_Gradient",
  "Logo": "kQc2fa_Logo",
  "LogoContainer": "kQc2fa_LogoContainer",
  "NoBg": "kQc2fa_NoBg",
  "Phone": "kQc2fa_Phone",
  "PinkBlue": "kQc2fa_PinkBlue",
  "PinkOrange": "kQc2fa_PinkOrange",
  "PinkPurple": "kQc2fa_PinkPurple",
  "PlattanDesktop": "kQc2fa_PlattanDesktop",
  "PlattanMobile": "kQc2fa_PlattanMobile",
  "Root": "kQc2fa_Root",
  "Title": "kQc2fa_Title",
  "Video": "kQc2fa_Video",
  "White": "kQc2fa_White",
});
